import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getStandardTaxRelief,
  getNonTaxableIncomeLimit,
} from "../../Redux/Actions/salarycalculation";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";
//windowsize
import useWindowSize from "../../Component/use-window-size";
import { initialState } from "../../Redux/Reducers/salaryCalculationTaxFigures";

const StandardTaxRelief = ({ setHeadingFocused }) => {
  //get current windowsize
  const size = useWindowSize();
  const [cardFocused, setCardFocused] = useState(false);
  const [input, setInput] = useState(initialState.standardTaxRelief);
  const [inputCutOffValue, setInputCutOffValue] = useState(
    initialState.StandardTaxReliefCutOffValue
  );

  const dispatch = useDispatch();
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);

  function handleChange(e, input) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    e.preventDefault();
    if (e.target.value.match(regex)) {
      if (input === "cutOffValue") {
        setInputCutOffValue(parseInt(e.target.value) || "");
      }
      if (input === "input") {
        setInput(parseInt(e.target.value) || "");
      }
    } else {
      e.target.value = e.target.value.replace(/[^/\d\d{1,2}]/g, "");
      dispatch(
        getErrorMessage(`Felaktig inmatning, var god skriv in siffror!`)
      );
      const delayEditData = setTimeout(() => {
        dispatch(getErrorMessage(""));
      }, 5000);
      return () => clearTimeout(delayEditData);
    }
  }

  useEffect(() => {
    dispatch(getNonTaxableIncomeLimit(inputCutOffValue));
    dispatch(getStandardTaxRelief(input));
  }, [dispatch, input, inputCutOffValue]);

  const card = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    width: "100%",
  };
  const heading = {
    color: cardFocused ? "#000000" : "#777",
    overflow: "hidden",
    whiteSpace: "nowrap",
    cursor: "default",
  };
  const inputElement = {
    color: cardFocused ? "#000000" : "#777",
  };
  const outputElement = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    borderColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    color: cardFocused ? "#000000" : "#777",
    cursor: "default",
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  return (
    <>
      {size.width < sizeForMobile ? (
        <Row
          className="g-0 mt-2 m-auto rounded-3"
          style={card}
          onFocus={() => setCardFocused(true)}
          onBlur={() => setCardFocused(false)}
        >
          <Col
            xs={40}
            className="p-1 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={heading}
          >
            Grundavdrag
          </Col>
          {/* <Col xs={7} className="offset-1 p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className="form-control text-center"
          name="cutOffValue"
          style={inputElement}
          defaultValue={inputCutOffValue}
          autoComplete="off"
          onChange={(e) => handleChange(e, "cutOffValue")}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col> */}
          <Col xs={15} className="offset-0 p-1" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              {/* useState percent replace as hardcoded value */}
              {inputCutOffValue}
            </output>
          </Col>
          <Col xs={17} className="offset-3 p-0" style={{ padding: "0px" }}>
            <input
              type="text"
              className="form-control text-center "
              name="amount"
              style={inputElement}
              defaultValue={input}
              autoComplete="off"
              maxLength="7"
              onChange={(e) => handleChange(e, "input")}
              onFocus={(e) => setHeadingFocused(e.target.name)}
              onBlur={() => setHeadingFocused("")}
            />
          </Col>
        </Row>
      ) : (
        <Row
          className="g-0 mt-2 m-auto rounded-3"
          style={card}
          onFocus={() => setCardFocused(true)}
          onBlur={() => setCardFocused(false)}
        >
          <Col
            xs={17}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={heading}
          >
            Grundavdrag
          </Col>
          {/* <Col xs={7} className="offset-1 p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className="form-control text-center"
          name="cutOffValue"
          style={inputElement}
          defaultValue={inputCutOffValue}
          autoComplete="off"
          onChange={(e) => handleChange(e, "cutOffValue")}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col> */}
          <Col xs={6} className="offset-4 p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              {/* useState percent replace as hardcoded value */}
              {inputCutOffValue}
            </output>
          </Col>
          <Col xs={7} className="offset-6 p-2" style={{ padding: "0px" }}>
            <input
              type="text"
              className="form-control text-center "
              name="amount"
              style={inputElement}
              defaultValue={input}
              autoComplete="off"
              maxLength="7"
              onChange={(e) => handleChange(e, "input")}
              onFocus={(e) => setHeadingFocused(e.target.name)}
              onBlur={() => setHeadingFocused("")}
            />
          </Col>
        </Row>
      )}
    </>
  );
};
export default StandardTaxRelief;
